import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __awaiter, __decorate } from "tslib";
import { ToneAudioBuffer } from "../../core/context/ToneAudioBuffer";
import { defaultArg, optionsFromArguments } from "../../core/util/Defaults";
import { noOp } from "../../core/util/Interface";
import { isUndef } from "../../core/util/TypeCheck";
import { Source } from "../Source";
import { ToneBufferSource } from "./ToneBufferSource";
import { assertRange } from "../../core/util/Debug";
import { timeRange } from "../../core/util/Decorator";
/**
 * Player is an audio file player with start, loop, and stop functions.
 * @example
 * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/gong_1.mp3").toDestination();
 * // play as soon as the buffer is loaded
 * player.autostart = true;
 * @category Source
 */

export var Player = /*#__PURE__*/function (_Source) {
  _inherits(Player, _Source);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    _this = _super.call(this, optionsFromArguments(Player.getDefaults(), arguments, ["url", "onload"]));
    _this.name = "Player";
    /**
     * All of the active buffer source nodes
     */

    _this._activeSources = new Set();
    var options = optionsFromArguments(Player.getDefaults(), arguments, ["url", "onload"]);
    _this._buffer = new ToneAudioBuffer({
      onload: _this._onload.bind(_assertThisInitialized(_this), options.onload),
      onerror: options.onerror,
      reverse: options.reverse,
      url: options.url
    });
    _this.autostart = options.autostart;
    _this._loop = options.loop;
    _this._loopStart = options.loopStart;
    _this._loopEnd = options.loopEnd;
    _this._playbackRate = options.playbackRate;
    _this.fadeIn = options.fadeIn;
    _this.fadeOut = options.fadeOut;
    return _this;
  }

  _createClass(Player, [{
    key: "load",
    value:
    /**
     * Load the audio file as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * Note: this does not need to be called if a url
     * was passed in to the constructor. Only use this
     * if you want to manually load a new url.
     * @param url The url of the buffer to load. Filetype support depends on the browser.
     */
    function load(url) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._buffer.load(url);

              case 2:
                this._onload();

                return _context.abrupt("return", this);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Internal callback when the buffer is loaded.
     */

  }, {
    key: "_onload",
    value: function _onload() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noOp;
      callback();

      if (this.autostart) {
        this.start();
      }
    }
    /**
     * Internal callback when the buffer is done playing.
     */

  }, {
    key: "_onSourceEnd",
    value: function _onSourceEnd(source) {
      // invoke the onstop function
      this.onstop(this); // delete the source from the active sources

      this._activeSources.delete(source);

      if (this._activeSources.size === 0 && !this._synced && this._state.getValueAtTime(this.now()) === "started") {
        // remove the 'implicitEnd' event and replace with an explicit end
        this._state.cancel(this.now());

        this._state.setStateAtTime("stopped", this.now());
      }
    }
    /**
     * Play the buffer at the given startTime. Optionally add an offset
     * and/or duration which will play the buffer from a position
     * within the buffer for the given duration.
     *
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     */

  }, {
    key: "start",
    value: function start(time, offset, duration) {
      _get(_getPrototypeOf(Player.prototype), "start", this).call(this, time, offset, duration);

      return this;
    }
    /**
     * Internal start method
     */

  }, {
    key: "_start",
    value: function _start(startTime, offset, duration) {
      // if it's a loop the default offset is the loopStart point
      if (this._loop) {
        offset = defaultArg(offset, this._loopStart);
      } else {
        // otherwise the default offset is 0
        offset = defaultArg(offset, 0);
      } // compute the values in seconds


      var computedOffset = this.toSeconds(offset); // compute the duration which is either the passed in duration of the buffer.duration - offset

      var origDuration = duration;
      duration = defaultArg(duration, Math.max(this._buffer.duration - computedOffset, 0));
      var computedDuration = this.toSeconds(duration); // scale it by the playback rate

      computedDuration = computedDuration / this._playbackRate; // get the start time

      startTime = this.toSeconds(startTime); // make the source

      var source = new ToneBufferSource({
        url: this._buffer,
        context: this.context,
        fadeIn: this.fadeIn,
        fadeOut: this.fadeOut,
        loop: this._loop,
        loopEnd: this._loopEnd,
        loopStart: this._loopStart,
        onended: this._onSourceEnd.bind(this),
        playbackRate: this._playbackRate
      }).connect(this.output); // set the looping properties

      if (!this._loop && !this._synced) {
        // cancel the previous stop
        this._state.cancel(startTime + computedDuration); // if it's not looping, set the state change at the end of the sample


        this._state.setStateAtTime("stopped", startTime + computedDuration, {
          implicitEnd: true
        });
      } // add it to the array of active sources


      this._activeSources.add(source); // start it


      if (this._loop && isUndef(origDuration)) {
        source.start(startTime, computedOffset);
      } else {
        // subtract the fade out time
        source.start(startTime, computedOffset, computedDuration - this.toSeconds(this.fadeOut));
      }
    }
    /**
     * Stop playback.
     */

  }, {
    key: "_stop",
    value: function _stop(time) {
      var computedTime = this.toSeconds(time);

      this._activeSources.forEach(function (source) {
        return source.stop(computedTime);
      });
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */

  }, {
    key: "restart",
    value: function restart(time, offset, duration) {
      _get(_getPrototypeOf(Player.prototype), "restart", this).call(this, time, offset, duration);

      return this;
    }
  }, {
    key: "_restart",
    value: function _restart(time, offset, duration) {
      this._stop(time);

      this._start(time, offset, duration);
    }
    /**
     * Seek to a specific time in the player's buffer. If the
     * source is no longer playing at that time, it will stop.
     * @param offset The time to seek to.
     * @param when The time for the seek event to occur.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/gurgling_theremin_1.mp3", () => {
     * 	player.start();
     * 	// seek to the offset in 1 second from now
     * 	player.seek(0.4, "+1");
     * }).toDestination();
     */

  }, {
    key: "seek",
    value: function seek(offset, when) {
      var computedTime = this.toSeconds(when);

      if (this._state.getValueAtTime(computedTime) === "started") {
        var computedOffset = this.toSeconds(offset); // if it's currently playing, stop it

        this._stop(computedTime); // restart it at the given time


        this._start(computedTime, computedOffset);
      }

      return this;
    }
    /**
     * Set the loop start and end. Will only loop if loop is set to true.
     * @param loopStart The loop start time
     * @param loopEnd The loop end time
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/malevoices_aa2_F3.mp3").toDestination();
     * // loop between the given points
     * player.setLoopPoints(0.2, 0.3);
     * player.loop = true;
     * player.autostart = true;
     */

  }, {
    key: "setLoopPoints",
    value: function setLoopPoints(loopStart, loopEnd) {
      this.loopStart = loopStart;
      this.loopEnd = loopEnd;
      return this;
    }
    /**
     * If loop is true, the loop will start at this position.
     */

  }, {
    key: "loopStart",
    get: function get() {
      return this._loopStart;
    },
    set: function set(loopStart) {
      this._loopStart = loopStart;

      if (this.buffer.loaded) {
        assertRange(this.toSeconds(loopStart), 0, this.buffer.duration);
      } // get the current source


      this._activeSources.forEach(function (source) {
        source.loopStart = loopStart;
      });
    }
    /**
     * If loop is true, the loop will end at this position.
     */

  }, {
    key: "loopEnd",
    get: function get() {
      return this._loopEnd;
    },
    set: function set(loopEnd) {
      this._loopEnd = loopEnd;

      if (this.buffer.loaded) {
        assertRange(this.toSeconds(loopEnd), 0, this.buffer.duration);
      } // get the current source


      this._activeSources.forEach(function (source) {
        source.loopEnd = loopEnd;
      });
    }
    /**
     * The audio buffer belonging to the player.
     */

  }, {
    key: "buffer",
    get: function get() {
      return this._buffer;
    },
    set: function set(buffer) {
      this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/breakbeat.mp3").toDestination();
     * player.loop = true;
     * player.autostart = true;
     */

  }, {
    key: "loop",
    get: function get() {
      return this._loop;
    },
    set: function set(loop) {
      // if no change, do nothing
      if (this._loop === loop) {
        return;
      }

      this._loop = loop; // set the loop of all of the sources

      this._activeSources.forEach(function (source) {
        source.loop = loop;
      });

      if (loop) {
        // remove the next stopEvent
        var stopEvent = this._state.getNextState("stopped", this.now());

        if (stopEvent) {
          this._state.cancel(stopEvent.time);
        }
      }
    }
    /**
     * Normal speed is 1. The pitch will change with the playback rate.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/femalevoices_aa2_A5.mp3").toDestination();
     * // play at 1/4 speed
     * player.playbackRate = 0.25;
     * // play as soon as the buffer is loaded
     * player.autostart = true;
     */

  }, {
    key: "playbackRate",
    get: function get() {
      return this._playbackRate;
    },
    set: function set(rate) {
      this._playbackRate = rate;
      var now = this.now(); // cancel the stop event since it's at a different time now

      var stopEvent = this._state.getNextState("stopped", now);

      if (stopEvent && stopEvent.implicitEnd) {
        this._state.cancel(stopEvent.time);

        this._activeSources.forEach(function (source) {
          return source.cancelStop();
        });
      } // set all the sources


      this._activeSources.forEach(function (source) {
        source.playbackRate.setValueAtTime(rate, now);
      });
    }
    /**
     * If the buffer should be reversed
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/chime_1.mp3").toDestination();
     * player.autostart = true;
     * player.reverse = true;
     */

  }, {
    key: "reverse",
    get: function get() {
      return this._buffer.reverse;
    },
    set: function set(rev) {
      this._buffer.reverse = rev;
    }
    /**
     * If the buffer is loaded
     */

  }, {
    key: "loaded",
    get: function get() {
      return this._buffer.loaded;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Player.prototype), "dispose", this).call(this); // disconnect all of the players


      this._activeSources.forEach(function (source) {
        return source.dispose();
      });

      this._activeSources.clear();

      this._buffer.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Source.getDefaults(), {
        autostart: false,
        fadeIn: 0,
        fadeOut: 0,
        loop: false,
        loopEnd: 0,
        loopStart: 0,
        onload: noOp,
        onerror: noOp,
        playbackRate: 1,
        reverse: false
      });
    }
  }]);

  return Player;
}(Source);

__decorate([timeRange(0)], Player.prototype, "fadeIn", void 0);

__decorate([timeRange(0)], Player.prototype, "fadeOut", void 0);